import React from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import { useOnboardingFlow } from '../../../../store/onboarding/useOnboardingFlow'
import { useOnboardingActions } from '../../../../store/onboarding/useOnboardingActions'
import { OnboardingFlowStatus } from '../../../../models/Onboarding'
import styles from './OnboardingProgressWidget.module.scss'
import { OnboardingDismissConfirmModal } from '../OnboardingModals/OnboardingDismissConfirmModal/OnboardingDismissConfirmModal'

interface OnboardingProgressWidgetProps {
  collapsed: boolean
}

export const OnboardingProgressWidget: React.FC<OnboardingProgressWidgetProps> = ({ collapsed }) => {
  const { flow, isLoading, isError } = useOnboardingFlow()
  const { completedOrSkippedCount, totalCount, areAllStepsCompleted, isDismissingFlow, isCompletingFlow, handleDismiss, handleConfirmDismiss, handleComplete } =
    useOnboardingActions(flow)

  const visible = !isLoading && !isError && flow?.status === OnboardingFlowStatus.ACTIVE

  return (
    <>
      <OnboardingDismissConfirmModal onConfirmDismiss={handleConfirmDismiss} isDismissing={isDismissingFlow} isBusy={isDismissingFlow || isCompletingFlow} />
      {visible ? (
        <div className='zocks-px-1.25 pt-3 pb-2'>
          <NavLink
            to='/onboarding'
            className={({ isActive }) =>
              classNames(styles.widget, 'p-2 rounded-2 text-decoration-none text-white', {
                [styles.widgetActive]: isActive,
                'd-flex align-items-center justify-content-center': collapsed,
                'd-flex flex-column': !collapsed,
              })
            }
          >
            {collapsed ? (
              <i className={classNames('bi bi-rocket-takeoff', styles.icon)} />
            ) : (
              <>
                <div className='d-flex align-items-center gap-2 w-100'>
                  <i className={classNames('bi bi-rocket-takeoff flex-shrink-0', styles.icon)} />
                  <span className={classNames(styles.label, 'flex-grow-1 fw-bold text-nowrap overflow-hidden text-truncate')}>Getting Started</span>
                  <button
                    type='button'
                    className={classNames(styles.closeBtn, 'btn btn-link p-0 text-white flex-shrink-0')}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleDismiss()
                    }}
                    disabled={isDismissingFlow || isCompletingFlow}
                  >
                    <i className='bi bi-x' />
                  </button>
                </div>
                <div className={classNames(styles.segments, 'd-flex w-100 mt-2')}>
                  {Array.from({ length: totalCount }, (_, i) => (
                    <div
                      key={i}
                      className={classNames(styles.segment, 'flex-fill', {
                        [styles.segmentFilled]: i < completedOrSkippedCount,
                      })}
                    />
                  ))}
                </div>
                {areAllStepsCompleted ? (
                  <button
                    type='button'
                    className={classNames(styles.finishBtn, 'd-flex align-items-center w-100 mt-2 text-white')}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleComplete()
                    }}
                    disabled={isDismissingFlow || isCompletingFlow}
                  >
                    <span className={classNames(styles.finishLabel, 'flex-grow-1 fw-bold text-start text-truncate')}>Finish setup</span>
                    <i className={classNames(styles.finishIcon, 'bi bi-chevron-right flex-shrink-0')} />
                  </button>
                ) : null}
              </>
            )}
          </NavLink>
        </div>
      ) : null}
    </>
  )
}
